<template>
    <div class="c-entrepneur-info">
        <div class="c-entrepneur-info__img">
            <card-thumbnail :image="data.card_image" :bg="backgroundColor" />
        </div>
        <ul class="c-entrepneur-info__copy t-content">
            <li>
                <h3 class="t-t3-heavy-bold | u-c-bright">{{ data.business[0].text }}</h3>
            </li>
            <li>
                <h2 class="t-t2-heavy | u-c-dark">{{ data.title }}</h2>
            </li>
            <li v-if="uid" class="c-entrepneur-info__copy__btn">
                <!-- <shared-plain-btn :copy="$t('btn.storyBehind')" :path="`${storyParentPath}/${uid}`" icon="arrow-circle-plain" /> -->
                <btn
                    tag="router-link"
                    :href="`${storyParentPath}/${uid}`"
                    :label="$t('btn.storyBehind')"
                    color="bright"
                    icon-after="arrow-right"
                    :small="true"
                />
                <!-- class="l-section__return" -->
            </li>
        </ul>
    </div>
</template>

<script>
import { storyParentPath } from "src/router";

import Btn from "components/Btn";
import CardThumbnail from "objects/Card/CardThumbnail";
import SharedPlainBtn from "components/Shared/SharedPlainBtn";

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        uid: {
            type: String,
            required: false,
            default: null,
        },
    },

    components: {
        Btn,
        CardThumbnail,
        SharedPlainBtn,
    },
    computed: {
        backgroundColor() {
            return this.data.body.length && this.data.body[0].primary.bg ? this.data.body[0].primary.bg : "dark";
        },
        storyParentPath() {
            return storyParentPath;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-entrepneur-info {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;
    width: 100%;

    li {
        &:nth-child(2) {
            @media #{$breakpoint-vertical} {
                margin-top: 0.5rem; //overwrite code use somewhere else
            }
        }
    }

    @media #{$breakpoint-horizontal} {
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }

    &--reverse {
        justify-content: flex-end;
    }

    &__img {
        display: flex;
        width: 100%;
        justify-content: center;
        @media #{$breakpoint-horizontal} {
            width: auto;
            margin-right: var(--grid-gutter-triple);
        }
    }
    &__copy {
        @include reset-list;

        display: flex;
        flex-direction: column;

        padding-top: var(--grid-gutter);
        @media #{$breakpoint-horizontal} {
            padding-top: 0px;
            max-width: 600px;
        }
        &__btn {
            margin-top: 2rem; //same as c-btn
        }
    }
}
</style>
